import { useMemo, useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { reviews, reviewTags } from "@/mocks/film";

export default function ReviewsSection() {
  const [tag, setTag] = useState("全部");

  const filtered = useMemo(
    () => (tag === "全部" ? reviews : reviews.filter((item) => item.tag === tag)),
    [tag]
  );

  return (
    <section id="reviews" className="scroll-mt-32 bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="07 / 影迷短评"
            title="按维度归档的观众观点"
            desc="下面几条短评来自观众整理，并按剧情、表演、节奏、摄影、结局几个方向打了标签。点击标签即可筛选，观点不代表统一评价。"
          />
        </Reveal>

        <Reveal delay={50}>
          <div className="mt-7 flex flex-wrap items-center gap-2">
            {reviewTags.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => setTag(item)}
                className={`px-4 py-2 rounded-full text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                  tag === item
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 border border-background-200 hover:text-foreground-950"
                }`}
                aria-pressed={tag === item}
              >
                {item}
              </button>
            ))}
            <span className="ml-1 text-xs text-foreground-500 font-label">
              共 {filtered.length} 条
            </span>
          </div>
        </Reveal>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {filtered.map((review, index) => (
            <Reveal key={review.user} delay={(index % 3) * 70}>
              <article className="h-full rounded-lg bg-background-100 border border-background-200 p-5 md:p-6 flex flex-col">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-secondary-200 text-secondary-900 flex items-center justify-center font-heading font-bold">
                    {review.user.slice(0, 1)}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-foreground-950 truncate">{review.user}</p>
                    <p className="text-xs text-foreground-500 font-label">{review.date}</p>
                  </div>
                  <span className="shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-label">
                    <i className="ri-star-fill" aria-hidden="true" />
                    {review.score.toFixed(1)}
                  </span>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-foreground-700 flex-1">
                  {review.text}
                </p>
                <div className="mt-4 pt-4 border-t border-background-200">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-background-200 text-foreground-600 text-xs font-label">
                    <i className="ri-price-tag-3-line" aria-hidden="true" />
                    {review.tag}
                  </span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}